import { createFileRoute } from "@tanstack/react-router";
import { Sanierung } from "../features/shell/Sanierung";

export const Route = createFileRoute("/sanierung")({
  component: Sanierung,
});
